import { TableAdapter } from '@makyoapp/makyo-common/dist/adapter/TableAdapter'

export function generateUniqueTableName(name: string, tables: TableAdapter[]): string {
  const existingTableNames = tables.map((table) => table.name)
  let uniqueName = name
  let copyCount = 1

  while (existingTableNames.includes(uniqueName)) {
    uniqueName = `${name}${copyCount === 1 ? ' copy' : ` copy ${copyCount}`}`
    copyCount++
  }

  return uniqueName
}
